import React from 'react';
import { string, func } from 'prop-types';
import styled from 'styled-components';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';

import Button from '../Button';
import TextInput from '../TextInput/TextInput';
import Wrapper from '../Wrapper';
import Container from '../Container/Container';

const SearchWidgetWrapper = styled(Wrapper)`
  position: relative;
  background-color: ${({ theme }) => theme.colors.greyLighter};
`;

const SearchWidgetContainer = styled(Container)`
  display: flex;
  padding-top: ${({ theme }) => `${theme.space[6]}px`};
  padding-bottom: ${({ theme }) => `${theme.space[4]}px`};
  position: relative;
`;

const InputGroup = styled(Wrapper)`
  display: flex;
  margin-right: ${({ theme }) => `${theme.space[5]}px`};
  width: 100%;
`;

const Destination = styled(Wrapper)`
  width: 100%;
  margin-right: ${({ theme }) => `${theme.space[5]}px`};
`;

const TextInputStyled = styled(TextInput)`
  background-color: ${({ theme }) => theme.colors.primaryWhite};
`;

const LeftInputStyled = styled(TextInputStyled)`
  border: '0px solid';
  border-radius: 4px 0 0 4px;
  border-width: 1px 0 1px 1px;
  min-width: 125px;
  width: 100%;
`;

const RightInputStyled = styled(TextInputStyled)`
  border-radius: 0px 4px 4px 0px;
  min-width: 125px;
  width: 100%;
`;

const LinkOverlay = styled(Wrapper)`
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 1;
  top: 0;
  left: 0;
  display: block;
`;

const FakeSearchWidget = ({
  origin,
  dest,
  fromDate,
  toDate,
  guests,
  onClickEditSearch,
}) => {
  return (
    <SearchWidgetWrapper display={['none', 'block']} id="search-widget-header">
      <LinkOverlay onClick={onClickEditSearch} />
      <SearchWidgetContainer>
        {origin ? (
          <InputGroup>
            <LeftInputStyled
              boxProps={{ className: 'origin' }}
              label={translate('common.from')}
              value={origin}
            />
            <RightInputStyled
              boxProps={{ className: 'destination' }}
              label={translate('common.to')}
              value={dest}
            />
          </InputGroup>
        ) : (
          <Destination>
            <TextInputStyled
              boxProps={{ className: 'destination' }}
              label={translate('common.destination')}
              value={dest}
            />
          </Destination>
        )}
        <InputGroup maxWidth={280}>
          <LeftInputStyled
            boxProps={{ className: 'check-in' }}
            label={translate('common.checkIn')}
            value={fromDate}
          />
          <RightInputStyled
            boxProps={{ className: 'check-out' }}
            label={translate('common.checkOut')}
            value={toDate}
          />
        </InputGroup>
        <Wrapper mr={24} width={'100%'}>
          <TextInputStyled
            boxProps={{ className: 'booking-summary' }}
            label={translate('common.roomAndGuest')}
            value={guests}
          />
        </Wrapper>
        <Wrapper className="search-btn" width={'100%'} maxWidth={184}>
          <Button disabled big block>
            {translate('common.search')}
          </Button>
        </Wrapper>
      </SearchWidgetContainer>
    </SearchWidgetWrapper>
  );
};

FakeSearchWidget.propTypes = {
  origin: string,
  dest: string,
  fromDate: string,
  toDate: string,
  guests: string,
  onClickEditSearch: func,
};

export default FakeSearchWidget;
